import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { RootDirective, SvgDirective } from '@pure/hive';
import { FbNorwayEolRenderInfo } from '../../../../data/models/recommendations.models';
import { FormatDaysUntilPipe } from '../../../../ui/pipes/format-days-until.pipe';
import { registerAsCardPlugin } from '../../services/recommendation-component-registry.service';

/** Stable registry key for this plugin. Used as the lookup name on the corresponding RenderInfo. */
export const FB_NORWAY_EOL_CARD_PLUGIN_NAME = 'FbNorwayEolCardPluginComponent';

/**
 * Plugin component for the FlashBlade end-of-life (prorec-eol-fb-norway) card body.
 *
 * The card shell — target name, header badge, dismiss, footer — comes from
 * `RecommendationCardTemplateComponent`. This plugin owns only the body: the end-of-life
 * icon, the statement naming FlashBlade, and the count of days to the end-of-support date.
 * The model and the date itself are left to the dialog.
 */
@Component({
    selector: 'fb-norway-eol-card-plugin',
    templateUrl: './fb-norway-eol-card-plugin.component.html',
    styleUrls: ['./fb-norway-eol-card-plugin.component.scss'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    preserveWhitespaces: false,
    imports: [FormatDaysUntilPipe, RootDirective, SvgDirective],
})
export class FbNorwayEolCardPluginComponent {
    renderInfo = input.required<FbNorwayEolRenderInfo>();
}

registerAsCardPlugin(FB_NORWAY_EOL_CARD_PLUGIN_NAME, FbNorwayEolCardPluginComponent);
